import React, { useState, useEffect, useRef } from 'react';
import html2pdf from "html2pdf.js";
import { Image, message, Skeleton, Tabs, Tooltip, Upload } from 'components/shared/AntComponent';
import { Form, Input } from 'components/shared/FormComponent';
import { Button } from 'components/shared/ButtonComponent';
import 'assets/styles/auth.scss';
import 'assets/styles/form.scss';
import 'assets/styles/useragreement.scss';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas';
import { saveAgreement, verifyAgreemnet } from 'services/actions/accountAction';
import 'assets/styles/template.scss';
import { UserOutlined, BankOutlined } from 'components/shared/AntIcons';
import { agreePntConsent, getConsentLinkVerify } from 'services/actions/patientAction';
import EEGImage from 'assets/img/brandname.png';

const { Dragger } = Upload;

const PatientAgreement: React.FC = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { loading10, error10, success10, loading11, success11, error11, verifyLinkInfo } = useSelector((state: any) => state.patient);
    const sigCanvas = useRef<any>(null);
    const [isSigned, setIsSigned] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success11 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error11 : false;
    const [showSuccessmsg1, setShowSuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success10 : false;
    const [showErrormsg1, setShowErrormsg1] = useState(false);
    const errormsg1 = showErrormsg1 ? error10 : false;
    const [selectedTab, setSelectedTab] = useState("draw");
    const [penColor, setPenColor] = useState("black");
    const [uploadedImage, setUploadedImage]: any = useState(null);
    const isActionComplete =
        (selectedTab === "draw" && isSigned) ||
        (selectedTab === "upload" && uploadedImage);
    const url = window.location.href;
    const lastSegment = url.substring(url.lastIndexOf("/") + 1);

    const handleTabChange = (key) => {
        setSelectedTab(key);
    };
    const handleUploadChange = (info) => {
        const file = info?.fileList[0]?.originFileObj;

        if (info?.fileList?.length === 0) {
            setUploadedImage(null);
            return;
        }

        if (!file) return;

        const reader: any = new FileReader();
        reader.onload = (e) => setUploadedImage(e.target.result);
        reader.readAsDataURL(file);
    };


    const clearSignature = () => {
        sigCanvas.current?.clear();
        handleEnd();
    };
    const getSignatureDataUrl = (): string | null => {
        if (selectedTab === "draw" && sigCanvas.current && !sigCanvas.current.isEmpty()) {
            return sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        } else if (selectedTab === "upload" && uploadedImage) {
            return uploadedImage; // already base64 from FileReader
        }
        return null;
    };

    const handleEnd = () => {
        if (sigCanvas.current) {
            setIsSigned(!sigCanvas.current.isEmpty());
        }
    };
    const onPreview = async (file) => {
        let src = file.url || file.preview;
        if (!src) {
            src = await new Promise<string>((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result as string);
            });
        }
        const imgWindow = window.open("");
        if (imgWindow) {
            imgWindow.document.write(`<html><body><img src="${src}" style="max-width: 100%; height: auto;" /></body></html>`);
            imgWindow.document.close();
        }
    };
    const tabItems = [
        {
            key: "draw",
            label: <span className='fs-18'>Signature Pad</span>,
            children: (
                <>
                    <div className='bg-light temp-width w-100 signature-container'>
                        <div className="signature-header">
                            <span></span>
                            <button onClick={clearSignature} className="clear-btn">
                                Clear
                            </button>
                        </div>
                        <div className="signature-pad">
                            <SignatureCanvas
                                ref={sigCanvas}
                                penColor={penColor}
                                onEnd={handleEnd}
                                canvasProps={{
                                    width: 800,
                                    height: 200,
                                    className: "signcanvas",
                                }}
                            />
                        </div>
                        <div className="color-options">
                            <button className={`color-btn black ${penColor === "black" ? "active" : ""}`} onClick={() => setPenColor("black")} />
                            <button className={`color-btn blue ${penColor === "blue" ? "active" : ""}`} onClick={() => setPenColor("blue")} />
                            <button className={`color-btn red ${penColor === "red" ? "active" : ""}`} onClick={() => setPenColor("red")} />
                        </div>
                    </div>
                </>
            )
        },
        {
            key: "upload",
            label: <span className='fs-18'>Upload Signature Image</span>,
            children: (
                <>
                    <div className="signature-pad border-0">
                        <div className='upl-sign-cont sign-file d-flex justify-content-center py-5 bg-light'>
                            <Form form={form} layout="vertical">
                                <Form.Item name="uploadImg" className='m-0' valuePropName="uploadImg" >
                                    <Dragger
                                        name="file"
                                        multiple={false}
                                        maxCount={1}
                                        beforeUpload={() => false}
                                        listType="picture-card"
                                        accept=".png,.jpg,.jpeg"
                                        onChange={handleUploadChange}
                                        onPreview={onPreview}
                                    >
                                        <p className="ant-upload-drag-icon"></p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">
                                            Upload
                                            {' png, jpg, jpeg '}
                                            file here
                                        </p>
                                    </Dragger>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </>
            )
        }
    ];
    const handleUpload = async () => {
        setLoading(true);

        try {
            //  setTempLoading(true);
            const base64String = await handleDownloadPDF(false);
            if (!base64String) return;

            // Convert base64 → Blob → File (same as Ant Design Dragger file object)
            const byteCharacters = atob(base64String);
            const byteArray = new Uint8Array(Array.from(byteCharacters, (c) => c.charCodeAt(0)));
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // Create a proper File object like Ant Design Dragger
            const file = new File([blob], 'terms_and_conditions.pdf', {
                type: 'application/pdf',
                lastModified: Date.now(),
            });

            // const inputJson = {
            //     userid: Number(sessionStorage.getItem('userid')),
            //     accountid: Number(sessionStorage.getItem('accountid')),
            // };

            const inputJson = {
                "requestid": Number(verifyLinkInfo?.data?.id),
                "userid": 0
            };

            const formData = new FormData();
            formData.append("File", file);
            formData.append("InputJson", JSON.stringify(inputJson));

            dispatch(agreePntConsent(formData) as any);
            setShowSuccessmsg(true);
            setShowErrormsg(true);

        } catch (error) {
            console.error("Upload error:", error);
            setShowErrormsg(true);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        dispatch(getConsentLinkVerify(lastSegment) as any);
        setShowSuccessmsg1(true)
        setShowErrormsg1(true)
    }, [dispatch]);

    useEffect(() => {
        if (successmsg1) {
            setShowSuccessmsg1(false)
        }
        if (errormsg1) {
            if (error10?.message?.toLowerCase() == "invalid link" || error10?.message?.toLowerCase() == "link already used") {
                navigate('/link-expired');
            } else {
                navigate('/Page404');
                // message.error(error10?.message);
            }
            // navigate('/Page404');
            setShowErrormsg1(false);
        }
    }, [successmsg1, errormsg1]);

    useEffect(() => {
        if (successmsg) {
            setShowSuccessmsg(false);
            navigate('/consent-success');
        }
        if (errormsg) {
            if (error11?.message?.toLowerCase() == "invalid link" || error11?.message?.toLowerCase() == "") {
                navigate('/link-expired');
            } else {
                message.error(error11?.message);
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const isFirefox = () => navigator.userAgent.toLowerCase().includes('firefox');

    // const handleDownloadPDF = async (isDownload:boolean) => {
    //     const opt = {
    //         margin: [0, 0, 0, 0],
    //         filename: 'patient consent form.pdf',
    //         image: { type: 'jpeg', quality: 0.8 },
    //         html2canvas: { scale: isFirefox() ? 1 : 2, useCORS: true, letterRendering: true },
    //         jsPDF: { unit: 'mm', format: 'a4', orientation: 'Portrait' },
    //         enableLinks: true,
    //     };
    //     const element1: any = document.getElementById('patientagreement');
    //     const wrapper = document.createElement('div');
    //     if (element1) {
    //         const element1Clone = element1?.cloneNode(true) as HTMLElement;
    //         // Inject signature into the cloned DOM before PDF generation
    //         const signatureDataUrl = getSignatureDataUrl();
    //         const signaturePlaceholder = element1Clone.querySelector('#signature-placeholder');

    //         if (signaturePlaceholder) {
    //             if (signatureDataUrl) {
    //                 signaturePlaceholder.innerHTML = `
    //                 <img 
    //                     src="${signatureDataUrl}" 
    //                     alt="Signature" 
    //                     style="max-height: 100px; max-width: 300px; object-fit: contain;" 
    //                 />`;
    //             } else {
    //                 signaturePlaceholder.innerHTML = `
    //                 <div style="width: 300px; height: 60px; border-bottom: 1px solid #000;"></div>
    //                 <p style="font-size: 12px; color: #999;">No signature provided</p>`;
    //             }
    //         }

    //         wrapper.appendChild(element1Clone);
    //         try {
    //             const pdf = html2pdf().from(wrapper).set(opt);
    //             // if (isDownload) {
    //             let simulatedProgress = 0;
    //             const progressInterval = setInterval(() => {
    //                 if (simulatedProgress >= 100) {
    //                     clearInterval(progressInterval);
    //                     setLoading(false);
    //                 } else {
    //                     simulatedProgress += 10;
    //                     // setProgress(simulatedProgress);
    //                 }
    //             }, 100);
    //             // Save the PDF
    //             await pdf.save();
    //             // } else {
    //             //     let base64String = '';
    //             //     const pdfDataUrl = await html2pdf().from(wrapper).set(opt).output('datauristring');
    //             //     base64String = pdfDataUrl.split(',')[1];
    //             //     // setIsResultApprove(false);
    //             //     // releaseReq(base64String);
    //             // }
    //         } catch (error: any) {
    //             console.log('');
    //         }
    //     }
    // }

    const handleDownloadPDF = async (isDownload: boolean): Promise<string | null> => {
        const isIpad = /iPad/i.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const opt = {
            margin: [0, 0, 0, 0],
            filename: 'patient consent form.pdf',
            image: { type: 'jpeg', quality: 0.8 },
            html2canvas: { scale: isFirefox() ? 1 : isIpad ? 1 : 2, useCORS: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'Portrait' },
            enableLinks: true,
        };

        const element1: any = document.getElementById('patientagreement');
        if (!element1) return null;

        const wrapper = document.createElement('div');
        const element1Clone = element1.cloneNode(true) as HTMLElement;

        // Inject signature into the cloned DOM before PDF generation
        const signatureDataUrl = getSignatureDataUrl();
        const signaturePlaceholder = element1Clone.querySelector('#signature-placeholder');

        if (signaturePlaceholder) {
            if (signatureDataUrl) {
                signaturePlaceholder.innerHTML = `
                <img 
                    src="${signatureDataUrl}" 
                    alt="Signature" 
                    style="max-height: 100px; max-width: 300px; object-fit: contain;" 
                />`;
            } else {
                signaturePlaceholder.innerHTML = `
                <div style="width: 300px; height: 60px; border-bottom: 1px solid #000;"></div>
                <p style="font-size: 12px; color: #999;">No signature provided</p>`;
            }
        }

        wrapper.appendChild(element1Clone);

        try {
            if (isDownload) {
                // Download the PDF
                let simulatedProgress = 0;
                const progressInterval = setInterval(() => {
                    if (simulatedProgress >= 100) {
                        clearInterval(progressInterval);
                        setLoading(false);
                    } else {
                        simulatedProgress += 10;
                    }
                }, 100);

                await html2pdf().from(wrapper).set(opt).save();
                return null;
            } else {
                // Return base64 string only (no download)
                const pdfDataUrl = await html2pdf().from(wrapper).set(opt).output('datauristring');
                const base64String = pdfDataUrl.split(',')[1];

                setLoading(false);

                return base64String;
            }

        } catch (error: any) {
            console.error('PDF generation error:', error);
            return null;
        }
    };
    return (
        <div className="container-fluid bg-light py-4 d-flex justify-content-center report-template">
            <Skeleton active loading={loading10}>
                <div className="w-auto bg-white shadow-sm border rounded" >
                    <div className='p-3 mb-4 bg-aliceblue border-bottom border-4'>
                        <h6 className='text-primary mb-4 ls-2'>PATIENT INFORMATION</h6>
                        <div className='d-flex'>
                            <div className='col d-flex'>
                                <div className="col-md-auto icon-cont-agreement d-flex justify-content-center align-items-center  border shadow-sm">
                                    <UserOutlined className="fs-15 text-primary" />
                                </div>
                                <div className="ps-2">
                                    <h6 className='text-muted fs-13 mb-0 fw-normal'>Patient Name</h6>
                                    <p className="mb-0 fs-14 fw-bold">{verifyLinkInfo?.data?.patient_name || "--"}</p>
                                </div>
                            </div>
                            <div className='col d-flex'>
                                <div className="col-md-auto icon-cont-agreement d-flex justify-content-center align-items-center border shadow-sm">
                                    <BankOutlined className="fs-15 text-primary" />
                                </div>
                                <div className="ps-2">
                                    <h6 className='text-muted fs-13 mb-0 fw-normal'>Account Name</h6>
                                    <p className="mb-0 fs-14 fw-bold">{verifyLinkInfo?.data?.account_name || "--"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white mx-auto user-agreement page-two" id="patientagreement">
                        <div className=" mb-4 pb-3 border-bottom">
                            <img className="term-logo" src={EEGImage} alt="EEG Logo" width="20%" />
                            <h2 className="text-center fw-bold mb-2 mt-4 text-dark">QEEG Consent</h2>
                            <h5 className="text-center fw-bold">
                                Informed Consent for Quantitative EEG or Brain Mapping
                            </h5>
                        </div>
                        <div className="mb-3">
                            <h6 className="fw-bold">Service Agreement</h6>
                            <p className="small">
                                The information and recommendations provided by Healthy Paths Inc.
                                dba Axon EEG Solutions (“Axon”, “we,” “us,” or “our”) in this TIERreport
                                (the “Report”) is for general informational and educational purposes
                                and is intended to be used solely as a diagnostic aid.
                            </p>
                        </div>
                        <div>
                            <h6 className="fw-bold">Privacy Policy</h6>
                            <p className="small mb-3">
                                While reviewing the Report it is important that you understand the following:
                            </p>

                            <ol className="small ps-3">
                                <li className="mb-3 fs-14">
                                    <span className="text-decoration-underline px-1 fs-14">NOT MEDICAL ADVICE / CONSULT YOUR PHYSICIAN.</span>{" "}
                                    THE REPORT DOES NOT CONTAIN MENTAL HEALTH OR MEDICAL ADVICE AND IS
                                    NOT A SUBSTITUTE FOR PROFESSIONAL THERAPY OR MEDICAL ADVICE.
                                    BEFORE TAKING ANY ACTIONS, INCLUDING LIFESTYLE CHANGES OR STARTING
                                    NEW MEDICATION (WHETHER PRESCRIPTION, OVER-THE-COUNTER, OR NATURAL
                                    SUPPLEMENTS) BASED UPON THE REPORT, WE STRONGLY RECOMMEND THAT YOU
                                    CONSULT WITH THE APPROPRIATE MENTAL HEALTH AND/OR MEDICAL
                                    PROFESSIONAL. YOU SHOULD NEVER DELAY SEEKING MEDICAL TREATMENT OR
                                    DISREGARD PROFESSIONAL MEDICAL ADVICE DUE TO INFORMATION OR
                                    RECOMMENDATIONS CONTAINED IN THIS REPORT. THE USE OF OR RELIANCE
                                    ON ANY INFORMATION OR RECOMMENDATIONS IS SOLELY AT YOUR OWN RISK.

                                </li>

                                <li className="mb-3">
                                    NO AXON AGENT OR EMPLOYEE SHALL PROVIDE ANY ADVICE OR SERVICES
                                    OUTSIDE THE SCOPE OF THEIR EXPERTISE OR LICENSURE.

                                </li>

                                <li className="mb-3">
                                    <span className="text-decoration-underline px-1">NO REPRESENTATIONS OR WARRANTIES.</span>{" "}
                                    ALL INFORMATION AND RECOMMENDATIONS IN THE REPORT ARE PROVIDED IN
                                    GOOD FAITH BUT ARE PROVIDED “AS IS,” WITHOUT WARRANTY OF ANY KIND,
                                    WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
                                    IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                                    PURPOSE, OR SATISFACTORY QUALITY. WE MAKE NO REPRESENTATION OF ANY
                                    KIND, EXPRESS OR IMPLIED, REGARDING THE ACCURACY, ADEQUACY,
                                    VALIDITY, RELIABILITY, AVAILABILITY, OR COMPLETENESS OF ANY
                                    INFORMATION OR RECOMMENDATION CONTAINED IN THE REPORT.

                                </li>

                                <li className="mb-3">
                                    QEEG DEVICES ARE CONSIDERED BY THE FDA TO BE A MEDICAL DEVICE.
                                    HOWEVER, THE FDA DOES NOT REGULATE THE USE OF THESE QEEG DEVICES IN
                                    THE CONTEXT OF AXON’S SERVICES.

                                </li>

                                <li className="mb-3">
                                    <span className="text-decoration-underline px-1">NO LIABILITY.</span>{" "}
                                    UNDER NO CIRCUMSTANCE SHALL AXON HAVE ANY LIABILITY TO YOU FOR ANY
                                    LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE
                                    REPORT OR RELIANCE ON ANY INFORMATION OR RECOMMENDATIONS PROVIDED
                                    IN THE REPORT. YOUR USE OF THE REPORT AND RELIANCE ON ANY
                                    INFORMATION OR RECOMMENDATIONS IS SOLELY AT YOUR OWN RISK. AXON
                                    HEREBY DISCLAIMS ANY AND ALL LIABILITY FOR ANY INJURY, DAMAGE, OR
                                    OTHER IMPACT ON YOUR HEALTH OR MEDICAL CONDITION, WHETHER CAUSED
                                    DIRECTLY OR INDIRECTLY BY YOUR USE OF THE INFORMATION OR
                                    RECOMMENDATIONS CONTAINED IN THE REPORT. IN NO CASE SHALL AXON’S
                                    LIABILITY, IF ANY, EXCEED THE AMOUNT YOU PAID FOR THE SERVICES
                                    PROVIDED.

                                </li>

                                <li className="mb-3">
                                    A COPY OF MY MINIMALLY RELEVANT MEDICAL HISTORY AND EEG DATA WILL BE
                                    SENT TO THE EEG ANALYST FOR REVIEW.

                                </li>
                                <div className="html2pdf__page-break"></div>
                                <li className="mb-3 mt-5">
                                    NON-IDENTIFYING DATA CONTAINED IN THE REPORT MAY BE USED IN EDUCATION AND RESEARCH. PRIVATE MEDICAL
                                    INFORMATION, INCLUDING YOUR TEST RESULTS, WILL NEVER BE SHARED OVER VOICEMAIL, EMAIL OR TEXT.
                                </li>
                            </ol>
                        </div>
                        <div className='ps-1 py-3'> <h6>Signature of the Patient</h6></div>
                        <div id="signature-placeholder" style={{ minHeight: '80px', marginTop: '8px' }}>
                            {/* Blank by default in the live view */}
                        </div>
                    </div>
                    <div className="px-4 py-0">

                        <div className="custom-tabs">
                            <Tabs
                                items={tabItems}
                                onChange={handleTabChange}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end align-items-center text-end mt-2 p-3">
                        <Tooltip title={!isActionComplete ? "Provide your signature to download" : ""}>
                            <Button type='primary' disabled={!isActionComplete} className='me-2' onClick={() => handleDownloadPDF(true)}>Download a copy</Button>
                        </Tooltip>
                        <Tooltip title={!isActionComplete ? "Please provide your signature to proceed" : ""}>
                            <Button type="primary" className="ms-auto"
                                disabled={!isActionComplete}
                                onClick={handleUpload}
                                loading={loading || loading11}>
                                Agree
                            </Button>
                        </Tooltip>
                    </div>
                </div>
            </Skeleton>
        </div>
    );
};

export default PatientAgreement;